export default class AuthState {
  token = '';
}
